var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comps-carda-item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{ref:"backimg",staticClass:"backimg centerimage",style:('background-image: url(' + _vm.imgurl + '); height: ' + _vm.height)}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65759b21","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Models/comps/cardIndustriesB.vue
// module id = null
// module chunks = 